export default "__VITE_ASSET__84787cd9__"